import React, { useState } from "react";
import API_URL from "../apiConfig";

// Utility for formatting dates to dd-mm-yyyy if needed
function formatDate(dateStr) {
  if (!dateStr) return "";
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) return dateStr;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [y, m, d] = dateStr.split("-");
    return `${d}-${m}-${y}`;
  }
  let d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
}

export default function ProfitLossReport({ token }) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [income, setIncome] = useState(0);
  const [expense, setExpense] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [fetched, setFetched] = useState(false);

  const fetchReport = async () => {
    setLoading(true);
    setError("");
    setFetched(false);

    try {
      // Use production API endpoint, send dates as yyyy-mm-dd
      const res = await fetch(
        `${API_URL}/api/income_expense/profitloss?from=${from}&to=${to}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) throw new Error("Could not fetch profit/loss data.");
      const data = await res.json();
      setIncome(Number(data.income) || 0);
      setExpense(Number(data.expense) || 0);
      setFetched(true);
    } catch (err) {
      setError(err.message);
      setIncome(0);
      setExpense(0);
    }
    setLoading(false);
  };

  const profitLoss = income - expense;
  const formattedIncome = income.toLocaleString("en-IN", { minimumFractionDigits: 2 });
  const formattedExpense = expense.toLocaleString("en-IN", { minimumFractionDigits: 2 });
  const formattedProfitLoss = Math.abs(profitLoss).toLocaleString("en-IN", { minimumFractionDigits: 2 });

  return (
    <div className="reports-section">
      <h3>Profit & Loss Report</h3>
      <div style={{ marginBottom: 12 }}>
        <label style={{ marginRight: 10 }}>From:</label>
        <input
          type="date"
          value={from}
          onChange={e => setFrom(e.target.value)}
        />
        <label style={{ marginLeft: 16, marginRight: 10 }}>To:</label>
        <input
          type="date"
          value={to}
          onChange={e => setTo(e.target.value)}
        />
        <button
          style={{ marginLeft: 16 }}
          onClick={fetchReport}
          disabled={loading || !from || !to}
        >
          {loading ? "Loading..." : "Get Report"}
        </button>
      </div>
      {error && <div style={{ color: "red" }}>{error}</div>}
      {fetched && !loading && !error && (
        <div style={{ marginTop: 24 }}>
          <table className="iem-table" style={{ maxWidth: 500, margin: "0 auto" }}>
            <tbody>
              <tr>
                <td><strong>Total Income</strong></td>
                <td style={{ textAlign: "right" }}>{formattedIncome}</td>
              </tr>
              <tr>
                <td><strong>Total Expense</strong></td>
                <td style={{ textAlign: "right" }}>{formattedExpense}</td>
              </tr>
              <tr style={{ fontWeight: "bold", color: profitLoss >= 0 ? "green" : "red" }}>
                <td>{profitLoss >= 0 ? "Profit" : "Loss"}</td>
                <td style={{ textAlign: "right" }}>
                  {formattedProfitLoss}
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ textAlign: "center", marginTop: 16 }}>
            <span style={{ fontWeight: 600, fontSize: 16, color: profitLoss >= 0 ? "#388e3c" : "#d32f2f" }}>
              {profitLoss >= 0 ? "Net Profit" : "Net Loss"}: {formattedProfitLoss}
            </span>
          </div>
          <div style={{ textAlign: "center", marginTop: 8 }}>
            <span style={{ color: "#888" }}>
              Report Period: {formatDate(from)} to {formatDate(to)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}